<div
  class="modal-content text-light mb-0"
  style="background-color: #1e1e1e !important"
>
  <div
    class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0 shadow-none"
  >
    <div class="modal-title">
      <h4 class="mb-0">Select Serial Numbers</h4>
    </div>
    <button
      type="button"
      class="close-btn"
      style="margin-left: auto"
      (click)="closeModalClick()"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="modal-body pb-2 mt-4">
    <div class="d-flex flex-column gap-3">
      @for (item of [].constructor(item_count); track item; let i = $index) {
        <div class="row align-items-center">
          <label class="col-sm-4 col-form-label form-label text-end mb-0">
            Firearm {{ i + 1 }}:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <ng-select
              [items]="available_firearms_for_dispo_filtered"
              bindLabel="serial_number"
              bindValue="firearm_upc"
              [multiple]="false"
              [closeOnSelect]="true"
              class="form-control modern-input text-uppercase w-100 p-0 border-0 bg-transparent"
              placeholder="Select Serial Number"
              (change)="selectionChanged($event, i)"
            ></ng-select>
          </div>
        </div>
      }
    </div>

    <!-- Buttons -->
    <div class="d-flex justify-content-between mt-5 pt-3">
      <!--Cancel-->
      <button
        type="button"
        class="btn modern-btn secondary-btn px-4"
        (click)="closeModalClick()"
      >
        Cancel
      </button>

      <!--Save-->
      <button
        class="btn modern-btn primary-btn px-4"
        (click)="saveSelections()"
      >
        Save
      </button>
    </div>
  </div>
</div>

